import React from "react";
import PageLayout from "../components/PageLayout";
import SearchHeader from "../components/SearchHeader";
import Admin from "../components/admin/Admin";
import { useOption } from "../context/OptionContext";
import { useRole } from "../context/RoleContext";

const AdminPage = () => {
  const { categories, setCategories, statusOptions, setStatusOptions } =
    useOption();
  const { roles, setRoles } = useRole();
  return (
    <PageLayout>
      <SearchHeader />
      <div className="inner-main-content">
        <Admin
          categories={categories}
          setCategories={setCategories}
          statusOptions={statusOptions}
          setStatusOptions={setStatusOptions}
          roles={roles}
          setRoles={setRoles}
        />
      </div>
    </PageLayout>
  );
};

export default AdminPage;
